<template>
  <div>
    <div class="search-wrap">
      <div>
        <el-cascader
          ref="teamRef"
          style="width: 250px"
          v-model="team"
          clearable
          :options="teams"
          :placeholder="$t('config-manager::operate-config::请选择团队')"
          :props="{ value: 'id', label: 'name', children: 'children', checkStrictly: true }"
          @change="getAllData"
        ></el-cascader>
        <!-- <el-select v-model="params.campId" placeholder="请选择选择优化师">
          <el-option :label="item.name" :value="item.id" v-for="item in camps" :key="item.id"></el-option>
        </el-select> -->
        <el-date-picker
          v-model="params.dtMonth"
          type="month"
          :clearable="false"
          value-format="yyyy-MM"
          format="yyyy-MM"
          class="ml-16"
          @change="getAllData"
        ></el-date-picker>
      </div>
    </div>
    <el-row :gutter="20" class="card-content">
      <el-col
        :lg="6"
        :md="6"
        :sm="12"
        :xl="6"
        v-for="(item, index) in cardOptions"
        :key="index"
        class="card-item mt-18"
      >
        <dataCard :option="item" v-loading="cardLoading" :active="0"></dataCard>
      </el-col>
    </el-row>
    <div>
      <reportTable :config="teamTable" v-loading="loading.teamLoading">
        <div slot="other" v-if="drowText.length">
          <a v-for="(item, index) in drowText" :key="item.key" @click="upTeam(index)">
            {{ item.name }}
            <span style="margin: 0 8px" v-if="index < drowText.length - 1">-</span>
          </a>
        </div>
        <template v-for="(item, index) in teamTable.columns">
          <el-table-column :prop="item" :key="item" :label="item" min-width="120" v-if="drowText.length ? index === 0 : index === 1">
            <template slot-scope="{ row }">
              <a @click="drowTeam(item, row[item])" v-if="drowText.length < 2 && row[item]">{{ $dataCheck(row[item]) }}</a>
              <span v-else>{{ $dataCheck(row[item]) }}</span>
            </template> 
          </el-table-column>
          <el-table-column :prop="item" :key="item" :label="item" min-width="120" v-else>
            <template slot-scope="scope">
              <span>{{ $dataCheck(scope.row[item]) }}</span>
            </template>
          </el-table-column>
        </template>
      </reportTable>
    </div>
    <div>
      <reportTable :config="campTable" v-loading="loading.campLoading">
        <template v-for="(item, index) in campTable.columns">
          <el-table-column :prop="item" :key="index" :label="item" min-width="120">
            <template slot-scope="scope">
              <span>{{ $dataCheck(scope.row[item]) }}</span>
            </template>
          </el-table-column>
        </template>
      </reportTable>
    </div>
    <div>
      <reportTable :config="shopTable" v-loading="loading.shopLoading">
        <template v-for="(item, index) in shopTable.columns">
          <el-table-column :prop="item" :key="index" :label="item" min-width="120">
            <template slot-scope="scope">
              <span>{{ $dataCheck(scope.row[item]) }}</span>
            </template>
          </el-table-column>
        </template>
      </reportTable>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import dataCard from '@/components/data-analysis/card'
import reportTable from '@/components/data-analysis/table'
import detailConfig from './detailConfig'
import { getPerforDetail } from '@/server/etl'
import { teamList } from '@/server/team-manage'
import { getReports, queryData } from '@/server/dashboard'
export default {
  mixins: [detailConfig],
  components: { dataCard, reportTable },
  data() {
    return {
      cardLoading: false,
      team: [],
      params: {
        // optimist: '',
        dtMonth: moment().format('YYYY-MM'),
        orgUnitId: this.$store.state.user.merchantId
      },
      teams: [],
      cardOptions: [],
      teamTable: {},
      campTable: {},
      shopTable: {},
      loading: {
        teamLoading: false,
        campLoading: false,
        shopLoading: false
      },
      boardData: [],
      reports: [13043, 13044, 13045],
      drowText: []
    }
  },
  mounted() {
    this.getTeam()
    this.cardOptions = this.setCardOptions({})
    this.getAllData(false)
  },
  computed: {
    teamObj() {
      let obj = {}
      if (this.team) {
        if (this.team[0]) obj['sale_group_id'] = this.team[0]
        if (this.team[1]) obj['second_level_group_id'] = this.team[1]
        if (this.team[2]) obj['third_level_group_id'] = this.team[2]
      }
      return obj
    },
    teamName() {
      return (
        (this.$refs.teamRef &&
          this.$refs.teamRef.getCheckedNodes().length &&
          this.$refs.teamRef.getCheckedNodes()[0].pathLabels) ||
        []
      )
    }
  },
  methods: {
    drowTeam(key, name) {
      this.drowText.push({key, name})
      this.getTeamTable()
    },
    upTeam(index) {
      this.drowText = this.drowText.slice(0, index)
      this.getTeamTable()
    },
    getAllData(notInit = true) {
      this.getCardOptions()
      if (notInit) {
        this.getTeamTable()
        this.getCampTable()
        this.getShopTable()
      } else {
        this.setReportQueryInit(1, () => {
          this.getTeamTable()
          this.getCampTable()
          this.getShopTable()
        })
      }
    },
    async getCardOptions() {
      this.cardLoading = true
      const { data } = await getPerforDetail({
        ...this.params,
        ...this.teamObj
      })
      this.cardLoading = false
      if (data.code === this.$code) {
        this.cardOptions = this.setCardOptions(data.data.datas[0] || {})
      }
    },
    getTeamTable() {
      const reportId = 13043
      if (!this.reports.includes(reportId)) {
        return false
      }
      this.loading.teamLoading = true
      this.setReportQuery(1, reportId, data => {
        if (data.status === 200) {
          this.teamTable = this.setTeamTable(data.result.table)
        }
        this.loading.teamLoading = false
      })
    },
    getCampTable() {
      const reportId = 13044
      if (!this.reports.includes(reportId)) {
        return false
      }
      this.loading.campLoading = true
      this.setReportQuery(1, reportId, data => {
        if (data.status === 200) {
          this.campTable = this.setCampTable(data.result.table)
        }
        this.loading.campLoading = false
      })
    },
    getShopTable() {
      const reportId = 13045
      if (!this.reports.includes(reportId)) {
        return false
      }
      this.loading.shopLoading = true
      this.setReportQuery(1, reportId, data => {
        if (data.status === 200) {
          this.shopTable = this.setShopTable(data.result.table)
        }
        this.loading.shopLoading = false
      })
    },
    async getTeam() {
      const { data } = await teamList({
        pageNum: 1,
        pageSize: 10000
      })
      if (data.code === this.$code) {
        this.teams = (data.data && this.setTreeData(data.data.items)) || []
      }
    },
    setTreeData(arr) {
      const fn = arr => {
        return arr.map(item => {
          if (item.childrens && item.childrens.length) {
            item.children = fn(item.childrens)
          }
          return item
        })
      }
      return fn(arr)
    },

    // 报表数据构建Init
    async setReportQueryInit(boardID, callback) {
      if (!(this.boardData && this.boardData.length)) {
        const res = await getReports({
          boardID
        })
        if (!res.result[0]) {
          return false
        }
        this.boardData = res.result
        this.reports = this.reports.filter(item => res.result.map(report => report.reportID).includes(item))
      }

      callback()
    },
    // 报表数据构建
    async setReportQuery(boardID, reportId, callback) {
      if (!(this.boardData && this.boardData.length)) {
        const res = await getReports({
          boardID
        })
        if (!res.result[0]) {
          return false
        }
        this.boardData = res.result
      }
      const data = await queryData(
        this.setParamsReport(
          this.boardData.find(item => item.reportID == reportId),
          {
            ...this.params
          }
        )
      )
      callback(data)
    },
    // 构建report请求
    setParamsReport(result, params = {}) {
      result = this.$deepClone(result)
      // 配置params 别名
      const alias = []
      // 是否有时间匹配
      if (params.dtMonth) {
        alias.push('pay_month')
      }
      if (this.teamObj['sale_group_id']) {
        alias.push('sale_group_id')
      }
      if (this.teamObj['second_level_group_id']) {
        alias.push('second_level_group_id')
      }
      if (this.teamObj['third_level_group_id']) {
        alias.push('third_level_group_id')
      }
      let dimensions = result.requestDimensions // 堆积过滤条件concat 条件conditions
      const filters = result.otherParams.filter // 过滤条件，用alias取对应的uuid
      const pageSize = result.otherParams.pageSize
      let conditions = result.requestConditions
      let dirlls = result.drillDimensions
      const measures = result.requestMeasures
      // 判断alias 是否匹配到filters值
      alias.forEach(alia => {
        if (filters.some(item => alia == item.alias)) {
          const conditionItem = filters.find(item => alia == item.alias) || {}

          if (conditionItem.columnType == 'DATE') {
            conditions = conditions.filter(item => item.uuid != conditionItem.uuid)
            conditions.push({
              queryType: 'LARGEEQUAL',
              requestValue: [params.dtMonth],
              uuid: conditionItem.uuid
            })
            conditions.push({
              queryType: 'LESSEQUAL',
              requestValue: [params.dtMonth],
              uuid: conditionItem.uuid
            })
          } else {
            conditions = conditions.filter(item => item.uuid != conditionItem.uuid)
            const filterItem = filters.find(item => alia == item.alias)
            let queryType = ''
            if (filterItem) {
              queryType = filterItem.filterGroup.filterType.split('-').slice(1).join('').toUpperCase()
            }
            conditions.push({
              queryType,
              requestValue: alia === 'pay_month' ? [params.dtMonth] : [String(this.teamObj[alia])],
              uuid: conditionItem.uuid
            })
          }
        }
      })
      this.drowText.forEach(item => {
        dirlls.find(i => i.chinese === item.key.trim()).curDirll = item.name
        dimensions[0] = dirlls[dirlls.findIndex(i => i.chinese === item.key.trim()) + 1]
      })
      return {
        check: false,
        conditions,
        modelID: result.modelID,
        offSet: 1,
        pageSize,
        reportID: result.reportID,
        dimensions,
        measures,
        dirlls
      }
    }
  }
}
</script>

<style scoped lamg="scss"></style>
